import { Dayjs } from 'dayjs';
import { array, boolean, mixed, object, ObjectSchema, string } from 'yup';

import { ContactStatusDto } from '@/api/generated';
import {
  selectSearchOptionRequiredFieldsValidation,
  selectSearchOptionRequiredValidation,
} from '@/utils/form/selectSearchOptionOptional.validation.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix';
import { ContactsSearchFormModel } from '@/views/contacts/components/table/model/ContactsSearchForm.model.ts';

export const useContactsFormValidation = (): ObjectSchema<ContactsSearchFormModel> => {
  const { t } = useTranslationWithPrefix('validation');

  return object().shape({
    customerFullTextSearchInput: string()
      .required(t('general.required'))
      .min(3, t('minLength', { min: 3 }))
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .nullable(),
    fullTextSearchInput: string()
      .required(t('general.required'))
      .min(3, t('minLength', { min: 3 }))
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .nullable(),
    isAlreadyInCustomer: selectSearchOptionRequiredFieldsValidation<boolean>(
      boolean(),
      t,
    ).nullable(),
    isAlreadyInSupplier: selectSearchOptionRequiredFieldsValidation<boolean>(
      boolean(),
      t,
    ).nullable(),
    lastContactedFrom: mixed<Dayjs>().nullable(),
    lastContactedTo: mixed<Dayjs>().nullable(),
    ownerIds: array()
      .of(selectSearchOptionRequiredValidation<string>(string(), t))
      .required(t('general.required')),
    status: selectSearchOptionRequiredFieldsValidation<ContactStatusDto>(string(), t).nullable(),
  });
};
